/**
 * The phone app's words for the CRM's light edits (piece 35, *Light edits
 * (batch CR4)*; decision 4410): what the phone says about a save, a picture, a
 * tag, a custom field, a verify and a file row that the web does not already
 * say. Spread into the one string lookup beside the earlier batches' words. A
 * word the web already says, such as Edit, Save Changes, the contact window's
 * labels, Add Tag, Verify Address or Delete File, is read from the web's own
 * key and is not repeated here.
 */
export const CRM_EDIT_STRINGS = {
  'mobile.edit.unreachable': 'Nothing was saved, because the server did not answer. Check the connection, then press Save again.',
  'mobile.edit.notANumber': '{field} takes a number.',
  'mobile.edit.onTheWeb': 'Changed on the web:',
  'mobile.pick.offline': 'No signal, so the list cannot be read. The field keeps its value.',
  'mobile.picture.saving': 'Saving the picture…',
  'mobile.picture.notSaved': 'The picture was not saved.',
  'mobile.tags.removeTag': 'Remove {tag}',
  'mobile.tags.heldBecause': 'Type the tag to add.',
  'mobile.tags.notChanged': 'The tags were not changed.',
  'mobile.customFields.dateHint': 'Year, month and day, such as 2026-10-15.',
  'mobile.files.details': 'Details',
  'mobile.files.newVersionPhoto': 'New Version from Camera',
  'mobile.files.newVersionLibrary': 'New Version from Library',
  'mobile.files.versionSaved': 'The new version is filed.',
  'mobile.files.shareLink': 'Share Link',
  'mobile.files.shareSheet': 'Send the Link',
  'mobile.files.linkMade': 'The view link is made, ending when the organization’s default expiry says. Send it to whoever needs the file:',
  'mobile.files.notChanged': 'The file was not changed.',
} as const;
